module.exports = __webpack_public_path__ + "assets/PasswordVisibleIcon.5a80bd74.svg";